module.exports = __webpack_public_path__ + "assets/img/companyicon7.e8ea3f43.jpg";